import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const About = () => {
  return (
    <section id="about" className="py-5">
      <Container>
        <h2 className="text-center mb-4" style={{ color: '#0a4a7d', fontFamily: 'Montserrat, sans-serif', fontWeight: '700' }}>About Us</h2>
        <Row className="justify-content-center">
          <Col md={8} className="text-center">
            <p className="lead" style={{ fontFamily: 'Roboto, sans-serif' }}>
              ORM Trust is a non-profitable organization dedicated to enriching lives through completely charitable purposes. Our mission is driven by a strong sense of social responsibility, focusing on being a completely charitable, non-profitable entity.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default About;